// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("cards-rencontres", (element, {}, { cleanup }) => {
  const viewport = element.querySelector(".c-cards-rencontres__slider-viewport");
  if (!viewport) return console.warn("Trying to access uninitizialized viewport");

  const OPTIONS = { align: "start" } as const;

  const dom = {
    slides: element.querySelectorAll(".c-cards-rencontres__slider-slide"),
    viewportNode: ensureHTMLElement(viewport),
    container: ensureHTMLElement(element.querySelector(".c-cards-rencontres__slider-container")),
    nextBtnNode: ensureHTMLElement(element.querySelector(".c-cards-rencontres__btn-next")),
    prevBtnNode: ensureHTMLElement(element.querySelector(".c-cards-rencontres__btn-prev")),
  };

  //   If not enough slides to loop, duplicate them
  if (dom.slides.length < 5) {
    const originalSlides = Array.from(dom.slides);
    for (const slide of originalSlides) {
      dom.container.appendChild(slide.cloneNode(true));
    }
  }

  const emblaApi = EmblaCarousel(dom.viewportNode, OPTIONS);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, {
    nextBtn: dom.nextBtnNode,
    prevBtn: dom.prevBtnNode,
  });

  emblaApi.on("destroy", removePrevNextBtnsClickHandlers);

  cleanup(() => {
    emblaApi.destroy();
  });
});
